import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { getSettings } from "../lib/api";

const SCENE = "/api/media/manutenzione.jpeg";

export const MaintenanceGate = () => {
  const location = useLocation();
  const [on, setOn] = useState(false);
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return;
    getSettings()
      .then((s) => setOn(!!s.maintenance_mode))
      .catch(() => {});
  }, [isAdmin, location.pathname]);

  if (isAdmin || !on) return null;

  return (
    <div className="fixed inset-0 z-[90] bg-[#0D110D] flex items-center justify-center px-6 overflow-y-auto" data-testid="maintenance-screen">
      <div className="noise-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 max-w-3xl text-center py-16"
      >
        <img src="/logo-white.png" alt="Logo Birrificio Vecchio Cinghiale" className="h-14 w-auto object-contain mx-auto mb-10" />
        <div className="overflow-hidden border border-white/10 mb-10">
          <img src={SCENE} alt="Birrificio Vecchio Cinghiale — sito in manutenzione" className="w-full h-auto object-cover" />
        </div>
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D47738] mb-5">
          Sito in manutenzione
        </p>
        <h1 className="font-serif-display text-4xl md:text-6xl text-[#E8E2D2] leading-[0.95] mb-6">
          Stiamo <span className="italic text-[#D47738]">smanettando</span>
        </h1>
        <p className="text-[#E8E2D2]/60 max-w-lg mx-auto leading-relaxed">
          Il Vecchio Cinghiale ha le mani in pasta (e negli ingranaggi). Torniamo
          online a breve. Grazie per la pazienza!
        </p>
      </motion.div>
    </div>
  );
};
